import React, { useState } from "react";
import ScoreTypesStatsSection from "@/components/ScoreTypesStats/ScoreTypesStatsSection";
const scoreTypesName = {
    hole_in_one: "Hoyo en uno",
    birdie: "Birdie",
    eagle: "Eagle"
};
const ScoreTypesStatsListView = ({ data }) => {
    const [groupBy, setGroupBy] = useState('hole');
    return (React.createElement("div", { className: "listViewContainer" },
        React.createElement("div", { className: "listGroupBySelector" },
            React.createElement("div", { className: "ui buttons" },
                React.createElement("button", { className: `ui button ${groupBy === 'hole' ? 'primary' : ''}`, onClick: () => setGroupBy('hole') }, "Por hoyo"),
                React.createElement("button", { className: `ui button ${groupBy === 'player' ? 'primary' : ''}`, onClick: () => setGroupBy('player') }, "Por jugador"))),
        Object.values(data).map(({ scoreTypeKey, players }) => {
            return React.createElement(ScoreTypesStatsSection, { key: scoreTypeKey, scoreTypeName: scoreTypesName[scoreTypeKey], players: players, groupBy: groupBy });
        })));
};
export default ScoreTypesStatsListView;
